import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Nav from "@/components/portfolio/Nav";
import Hero from "@/components/portfolio/Hero";
import About from "@/components/portfolio/About";
import WorkGrid from "@/components/portfolio/WorkGrid";
import Contact from "@/components/portfolio/Contact";
import Footer from "@/components/portfolio/Footer";
import Resume from "@/components/portfolio/Resume";
import ProjectDetail from "@/components/portfolio/ProjectDetail";
import useReveal from "@/hooks/useReveal";

function Portfolio() {
  useReveal();
  return (
    <div className="App grain page-enter" data-testid="portfolio-root">
      <Nav />
      <main>
        <Hero />
        <About />
        <WorkGrid />
        <Resume />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#fbf9f5",
            color: "#161311",
            border: "1px solid rgba(0,0,0,0.12)",
            borderRadius: 0,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "12px",
            letterSpacing: "0.04em",
          },
        }}
      />
    </div>
  );
}

function ProjectPageWrapper() {
  return (
    <>
      <ProjectDetail />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#fbf9f5",
            color: "#161311",
            border: "1px solid rgba(0,0,0,0.12)",
            borderRadius: 0,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "12px",
            letterSpacing: "0.04em",
          },
        }}
      />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/projects/:slug" element={<ProjectPageWrapper />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
